import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "../../../environments/environment";

import {
  RequestOtpApiResponse,
  ValidateOtpApiResponse,
} from "../../shared/models/api.response";
import {
  RequestOtpViaMsisdnDTO,
  ValidateOtpDTO,
} from "../../shared/models/dto.models";

@Injectable({
  providedIn: "root",
})
export class OtpService {
  constructor(private http: HttpClient) {}

  requestOtp(
    mobile: RequestOtpViaMsisdnDTO
  ): Observable<HttpResponse<RequestOtpApiResponse>> {
    //return of({ status: 204 } as HttpResponse<RequestOtpApiResponse>); //Test

    return this.http.post<RequestOtpApiResponse>(
      `${environment.apiUri}/profile/request-signup-otp-sms`,
      { msisdn: mobile.msisdn, token: mobile.token },
      { observe: "response" }
    );
  }

  validateOtp(mobileOTP: ValidateOtpDTO): Observable<ValidateOtpApiResponse> {
    //return of({ match: true } as ValidateOtpApiResponse); //test

    return this.http.post<ValidateOtpApiResponse>(
      `${environment.apiUri}/profile/check-signup-otp`,
      { otp: mobileOTP.otp, msisdn: mobileOTP.msisdn }
    );
  }
}
